import AddTagToDataItemRequestModelBase from '../_generated/modelBases/add-tag-to-data-item-request-model-base';

export default class AddTagToDataItemRequestModel extends AddTagToDataItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
